const translations = {
    flightOverview: 'Flight Overview',
    mapOverview: 'Map Overview'
};

export default translations;
